import React from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext({});

export const ServerVarsContextConsumer = Context.Consumer;

export function ServerVarsContextProvider({
    children,
    showRoomTiles,
    showNegotiableBadge,
    swapMakeOffer,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
}) {
    return (
        <Context.Provider
            value={{
                showRoomTiles,
                showNegotiableBadge,
                swapMakeOffer,
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
            }}
        >
            {children}
        </Context.Provider>
    );
}

ServerVarsContextProvider.defaultProps = {
    showRoomTiles: false,
    showNegotiableBadge: false,
    swapMakeOffer: false,
    clientConf: {},
};

ServerVarsContextProvider.propTypes = {
    children: PropTypes.node,
    showRoomTiles: PropTypes.bool.isRequired,
    showNegotiableBadge: PropTypes.bool.isRequired,
    swapMakeOffer: PropTypes.bool.isRequired,
    isDesktop: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isSbAdsEnabled: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
    clientConf: PropTypes.object.isRequired,
};
